/* eslint-disable no-use-before-define */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import DataNotAvailablePage from 'reusable-components/data-not-found';
import useMessageDispatcher from '../../../hooks/useMessageDispatcher';
import axios from 'axios';

const headers = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken') || window.localStorage.getItem('webViewToken')}`,
        'Content-Type': 'application/json'
    }
};

const LabelledField = ({ label, children, labelWidth = '150px' }) => (
    <Box
        mb={1}
        sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { sm: 'center' },
            gap: 1
        }}
    >
        <Typography sx={{ width: { xs: '100%', sm: labelWidth }, fontSize: '14px', lineHeight: '32px', fontWeight: 500 }}>
            {label}
        </Typography>
        {children}
    </Box>
);

const CustomTextField = (props) => (
    <TextField
        variant="outlined"
        fullWidth
        size="small"
        InputProps={{
            style: {
                border: '1px solid black',
                borderRadius: 0,
                padding: 0,
                fontSize: '0.85rem'
            }
        }}
        sx={{
            bgcolor: '#fff',
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    border: '1px solid black',
                    borderRadius: 0
                },
                '&:hover fieldset': {
                    border: '1px solid black'
                },
                '&.Mui-focused fieldset': {
                    border: '1px solid black'
                }
            }
        }}
        {...props}
    />
);

const CompetitiveExam = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [exams, setExams] = useState([]);
    const [selectedExams, setSelectedExams] = useState([]);
    const [totalExamAmount, setTotalExamAmount] = useState(0);
    const [openExam, setOpenExam] = useState(false);
    const [examSubscriptionId, setExamSubscriptionId] = useState('');
    const showMessage = useMessageDispatcher();
    const location = useLocation();
    const studentData = location.state?.studentData;
    const navigate = useNavigate();
    const fetchIntrestCategories = async () => {
        try {
            const response = await axios.get(
                `/v1/fees/expression-of-interest-category-fees?interestType=EXAM&batchId=${studentData?.sessionId}`,
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    const data = response?.data?.data;
                    const newData = data?.map((item) => item?.subHeads).flat();
                    setExams(newData);
                    fetchSubscriptions();
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const handleSubscription = async () => {
        const payload = {
            // applicationId: admissionId,
            interestType: 'EXAM',
            subscriptionItems: selectedExams,
            userId: studentData?.userId
        };
        try {
            setIsLoading(true);
            const response = await axios.post(`/v1/fees/expression-of-interest-subscription`, payload, headers);
            if (response.status === 200) {
                navigate(-1);
                setIsLoading(false);
                fetchSubscriptions();
                if (response.data.code !== '403') {
                    showMessage({ message: response?.data?.Msg, color: 'success' });
                }
            }
        } catch (error) {
            setIsLoading(false);
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchSubscriptions = async () => {
        try {
            const response = await axios.get(
                `/v1/fees/expression-of-interest-subscription-details-by-user?userId=${studentData?.userId}`,
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    const data = response?.data?.data;
                    const examSubscriptionId = data?.find((item) => item?.interestType === 'EXAM')?.id;
                    const examDetails = data
                        ?.flatMap((item) => item?.subscriptionDetailsList || [])
                        ?.filter((elem) => elem?.subscriptionItem?.interestType === 'EXAM')
                        ?.flatMap((el) => el?.subscriptionItem?.id?.toString());
                    const examTotal = calculateTotalAmount(exams, examDetails);
                    setTotalExamAmount(examTotal);
                    setSelectedExams(examDetails);
                    setExamSubscriptionId(examSubscriptionId);
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const cancelSubscription = async (subscriptionId, interestType) => {
        try {
            const response = await axios.put(
                `/v1/fees/subscription-remove-for-admission?userId=${studentData?.userId}&subscriptionId=${subscriptionId}`,
                {},
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    showMessage({ message: response?.data?.Msg, color: 'error' });
                    if (interestType === 'EXAM') {
                        setSelectedExams([]);
                        setOpenExam(false);
                    }
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const calculateTotalAmount = (feeHeads, selectedIds) =>
        feeHeads?.reduce((total, item) => {
            const amountString = String(item?.amount || '0');
            if (selectedIds?.includes(item?.id?.toString())) {
                const fee = parseFloat(amountString?.replace(/[^\d.]/g, ''));
                if (!isNaN(fee)) {
                    return total + fee;
                }
            }
            return total;
        }, 0);
    useEffect(() => {
        fetchIntrestCategories();
    }, []);
    useEffect(() => {
        const examTotal = calculateTotalAmount(exams, selectedExams);
        setTotalExamAmount(examTotal);
    }, [selectedExams]);
    return (
        <MainCard>
            <Box
                sx={{
                    fontFamily: 'Arial, sans-serif',
                    maxWidth: '800px',
                    mx: 'auto',
                    p: 3,
                    bgcolor: '#f8d7da',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                }}
            >
                <Box
                    sx={{
                        textAlign: 'center',
                        mb: 3,
                        borderBottom: '2px solid #1a3c7e'
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2, bgcolor: '#f8d7da' }}>
                        <img src="/UniversityHeader.png" alt="University Header" style={{ maxWidth: '100%', height: 'auto' }} />
                    </Box>

                    <Typography variant="h4" sx={{ color: '#1a3c7e', mt: 1, mb: 2 }}>
                        Competitive Examination <br />
                        Expression of Interest
                    </Typography>
                </Box>

                <Box mb={3}>
                    <LabelledField label="Name of the Student:" labelWidth="100px">
                        <CustomTextField id="studentName" name="studentName" value={studentData?.studentName} aria-label="Student Name" />
                    </LabelledField>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            mb: 1
                        }}
                    >
                        <LabelledField label="Program:" labelWidth="100px">
                            <CustomTextField
                                id="course"
                                name="course"
                                value={studentData?.courseDetail?.course?.courseName}
                                sx={{ width: { xs: '100%', sm: '250px' } }}
                                aria-label="Program"
                            />
                        </LabelledField>

                        <LabelledField label="Roll No:" labelWidth="80px">
                            <CustomTextField
                                id="rollNo"
                                name="rollNo"
                                value={studentData?.rollNo}
                                sx={{ width: { xs: '100%', sm: '150px' } }}
                                aria-label="Roll Number"
                            />
                        </LabelledField>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            mb: 1
                        }}
                    >
                        <LabelledField label="Contact No:" labelWidth="100px">
                            <CustomTextField
                                id="contactNo"
                                name="contactNo"
                                value={studentData?.personalDetails?.phone}
                                sx={{ width: { xs: '100%', sm: '200px' } }}
                                aria-label="Contact Number"
                            />
                        </LabelledField>

                        <LabelledField label="Email:" labelWidth="80px">
                            <CustomTextField
                                id="email"
                                name="email"
                                type="email"
                                value={studentData?.personalDetails?.email}
                                sx={{ width: { xs: '100%', sm: '180px' } }}
                                aria-label="Email"
                            />
                        </LabelledField>
                    </Box>
                </Box>

                {exams?.length === 0 ? (
                    <DataNotAvailablePage text="No Data Found!" />
                ) : (
                    <Box mb={3} sx={{ overflowX: 'auto' }}>
                        <Paper variant="outlined" sx={{ borderColor: '#1a3c7e', minWidth: '600px' }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ bgcolor: '#1a3c7e' }}>
                                        {['SL.NO', 'Interest', 'Yearly Fee (Rs.)', 'Tick'].map((head) => (
                                            <TableCell
                                                key={head}
                                                style={{
                                                    color: 'white',
                                                    textAlign: 'center',
                                                    borderColor: '#1a3c7e',
                                                    padding: '8px'
                                                }}
                                            >
                                                {head}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {exams?.map((exam, i) => (
                                        <TableRow
                                            key={exam?.id}
                                            sx={{
                                                backgroundColor: i % 2 === 0 ? '#f2f2f2' : '#e6e6e6'
                                            }}
                                        >
                                            <TableCell sx={{ textAlign: 'center', borderColor: '#1a3c7e', borderRight: '1px solid' }}>
                                                {i + 1}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center', borderColor: '#1a3c7e', borderRight: '1px solid' }}>
                                                {exam?.name}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center', borderColor: '#1a3c7e', borderRight: '1px solid' }}>
                                                ₹ {exam?.amount}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center', borderColor: '#1a3c7e', borderRight: '1px solid' }}>
                                                <Checkbox
                                                    id={`exam-${exam?.id}`}
                                                    name="exams"
                                                    value={exam?.id}
                                                    checked={selectedExams?.includes(exam?.id?.toString())}
                                                    onChange={(e) => {
                                                        const examId = e.target.value;
                                                        const isChecked = e.target.checked;

                                                        if (isChecked) {
                                                            setSelectedExams((prev) => [...prev, examId]);
                                                        } else {
                                                            setSelectedExams((prev) => prev.filter((id) => id !== examId));
                                                        }
                                                    }}
                                                    sx={{
                                                        width: '16px',
                                                        height: '16px',
                                                        p: 0
                                                    }}
                                                    aria-label={`Select ${exam?.name}`}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Paper>
                        {!studentData?.interestExam && (
                            <Typography variant="h4" sx={{ mt: 2 }}>
                                Total Payable Amount: ₹{totalExamAmount}
                            </Typography>
                        )}
                    </Box>
                )}
                <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                    {/* <Button color="error" variant="contained" onClick={() => setOpenExam(true)}>
                        Cancel Subscription
                    </Button> */}
                    <Button
                        startIcon={isLoading && <CircularProgress color="error" size="1rem" />}
                        onClick={() => {
                            handleSubscription();
                        }}
                        disabled={isLoading || selectedExams?.length === 0}
                        color="secondary"
                        variant="contained"
                    >
                        {isLoading ? 'Please Wait' : studentData?.interestExam ? 'Update' : 'Submit'}
                    </Button>
                </Box>
                <Dialog open={openExam} onClose={() => setOpenExam(false)}>
                    <DialogTitle>Cancel Subscription</DialogTitle>

                    <DialogContent sx={{ width: '500px', p: 3 }}>
                        <Typography variant="body1">
                            Are you sure you want to cancel your subscription? This action cannot be undone.
                        </Typography>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => setOpenExam(false)} color="secondary" variant="contained">
                            No, keep it
                        </Button>
                        <Button onClick={() => cancelSubscription(examSubscriptionId, 'EXAM')} color="error" variant="contained" autoFocus>
                            Yes, cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </MainCard>
    );
};

export default CompetitiveExam;
